import { createEntityReducer, composeReducers } from 'ext/lib/collections';
import { TYPE, SPOOF_FAILED, ACCOUNT_SPOOFED } from './actions';

const entityReducer = createEntityReducer(TYPE);

const spoofErrorReducer = (state = null, action) => {
  switch (action.type) {
    case SPOOF_FAILED:
      return { ...state, spoofError: action.payload };
    case ACCOUNT_SPOOFED:
      // Clear error when a new spoof attempt starts
      return { ...state, spoofError: null };
    default:
      return state;
  }
};

export default composeReducers(entityReducer, spoofErrorReducer);

export const selectRedirecting = state => state[TYPE]?.redirecting;
export const selectSpoofing = state => state[TYPE]?.spoofing;
export const selectSpoofError = state => state[TYPE]?.spoofError;
